const initialState = {
  withMattress: false,
  size: {},
  mattressType: {
    value: "Orthopaedic",
    text: "Orthopaedic",
    priceToAdd: 0,
  },
  fabric: {
    text: "Plush",
    value: "plush",
    colors: [
      "Steel",
      "Silver",
      "Grey",
      "Black",
      "Mustard Blue",
      "Duck Egg",
      "Biege",
      "Teal",
      "Saphire",
      "Maroon",
    ],
  },
  color: "Steel",
  matchingStorageBox: false,
  drawer: {
    text: "No Drawers",
    value: "No Drawers",
    priceToAdd: 0,
  },
  bd: "Buttons",
};

const BedCustomizationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_BED_SIZE":
      return {
        ...state,
        size: action.payload,
      };

    case "SET_BED_COLOR":
      return {
        ...state,
        color: action.payload,
      };

    case "SET_BED_WITH_MATTRESS": {
      if (action.payload) {
        return {
          ...state,
          withMattress: action.payload,
          priceToAdd: state.priceToAdd + 500,
        };
      } else {
        return {
          ...state,
          withMattress: action.payload,
          priceToAdd: state.priceToAdd - 500,
        };
      }
    }

    case "SET_BED_MATTRESS_TYPE": {
      return {
        ...state,
        mattressType: action.payload,
      };
    }

    case "SET_BED_FABRIC": {
      return {
        ...state,
        color: action.payload.colors[0],
        fabric: action.payload,
      };
    }

    case "SET_MSB":
      return {
        ...state,
        matchingStorageBox: !state.matchingStorageBox,
      };
    case "SET_BED_DRAWER":
      return {
        ...state,
        drawer: action.payload,
      };
    case "SET_BED_BD":
      return {
        ...state,
        bd: action.payload,
      };
    default:
      return state;
  }
};

export default BedCustomizationsReducer;
